// extracted by mini-css-extract-plugin
module.exports = {"loading":"bZ","fullscreenWrapper":"b0","centeredSpinner":"b1","rotation":"b2","withoutLayer":"b3"};